import { render } from "./BeeEditor.vue?vue&type=template&id=4dab683b"
import script from "./BeeEditor.vue?vue&type=script&lang=js"
export * from "./BeeEditor.vue?vue&type=script&lang=js"

import "./BeeEditor.vue?vue&type=style&index=0&id=4dab683b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__